import { InterestedParty } from 'src/pages/payment-msi/PaymentMsiV2/types/interested-party.type';

export const purgeInterestedPartyForStore = (
  interestedParty: Partial<InterestedParty | undefined>,
) => {
  if (!interestedParty) {
    return null;
  }

  if (
    Object.values(interestedParty).every(
      (value) => value === '' || value === null || value === undefined,
    )
  ) {
    return null;
  }

  return interestedParty as InterestedParty;
};

export const purgeInterestedPartyForForm = (
  interestedParty: InterestedParty,
) => {
  if (!interestedParty) {
    return null;
  }

  if (!interestedParty.fullName && !interestedParty.email) {
    return null;
  }

  return interestedParty;
};
